var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    !!_vm.$store.state.pendingAction.moduleSessionCollection
      ? _c(
          "div",
          { attrs: { role: "tablist" } },
          [
            _vm._l(
              _vm.$store.state.pendingAction.moduleSessionCollection,
              function(moduleSessionItem, index_ms) {
                return _c(
                  "b-card",
                  {
                    key: index_ms,
                    staticClass: "mb-1",
                    attrs: { "no-body": "" }
                  },
                  [
                    _c(
                      "b-card-header",
                      {
                        staticClass: "p-1",
                        attrs: { "header-tag": "header", role: "tab" }
                      },
                      [
                        moduleSessionItem.moduleSession.seatTaken >= 25
                          ? _c(
                              "b-btn",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "moduleSessionTab[" + index_ms + "]",
                                    expression:
                                      "'moduleSessionTab['+index_ms+']'"
                                  }
                                ],
                                attrs: {
                                  block: "",
                                  href: "#",
                                  variant: "outline-danger"
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      moduleSessionItem.moduleSession.moduleName
                                    ) +
                                    " |\n          Time: " +
                                    _vm._s(
                                      _vm
                                        .$moment(
                                          moduleSessionItem.moduleSession[
                                            "sessionTimeRaw"
                                          ],
                                          [
                                            "X",
                                            "DD/MM/YYYY HH:mm",
                                            "DD-MM-YYYY HH:mm",
                                            _vm.$moment.ISO_8601
                                          ]
                                        )
                                        .format("DD-MM-YYYY HH:mm")
                                    ) +
                                    " |\n          Room: " +
                                    _vm._s(
                                      moduleSessionItem.moduleSession.roomId
                                    ) +
                                    " |\n          Seat-Left: " +
                                    _vm._s(
                                      moduleSessionItem.moduleSession
                                        .seatTotal -
                                        moduleSessionItem.moduleSession
                                          .seatTaken
                                    ) +
                                    " |\n          Language: " +
                                    _vm._s(
                                      moduleSessionItem.moduleSession.language
                                    ) +
                                    "|\n          Pending:" +
                                    _vm._s(
                                      _vm.$store.state.pendingAction
                                        .userCollection[
                                        moduleSessionItem.moduleSession.id
                                      ].length
                                    ) +
                                    "\n\n        "
                                )
                              ]
                            )
                          : moduleSessionItem.moduleSession.seatTaken >= 20
                            ? _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "moduleSessionTab[" + index_ms + "]",
                                      expression:
                                        "'moduleSessionTab['+index_ms+']'"
                                    }
                                  ],
                                  attrs: {
                                    block: "",
                                    href: "#",
                                    variant: "outline-warning"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession
                                          .moduleName
                                      ) +
                                      " |\n        Time: " +
                                      _vm._s(
                                        _vm
                                          .$moment(
                                            moduleSessionItem.moduleSession[
                                              "sessionTimeRaw"
                                            ],
                                            [
                                              "X",
                                              "DD/MM/YYYY HH:mm",
                                              "DD-MM-YYYY HH:mm",
                                              _vm.$moment.ISO_8601
                                            ]
                                          )
                                          .format("DD-MM-YYYY HH:mm")
                                      ) +
                                      " |\n        Room: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession.roomId
                                      ) +
                                      " |\n        Seat-Left: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession
                                          .seatTotal -
                                          moduleSessionItem.moduleSession
                                            .seatTaken
                                      ) +
                                      "|\n        Language: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession.language
                                      ) +
                                      "|\n        Pending:" +
                                      _vm._s(
                                        _vm.$store.state.pendingAction
                                          .userCollection[
                                          moduleSessionItem.moduleSession.id
                                        ].length
                                      ) +
                                      "\n\n      "
                                  )
                                ]
                              )
                            : _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "moduleSessionTab[" + index_ms + "]",
                                      expression:
                                        "'moduleSessionTab['+index_ms+']'"
                                    }
                                  ],
                                  attrs: {
                                    block: "",
                                    href: "#",
                                    variant: "outline-info"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession
                                          .moduleName
                                      ) +
                                      " |\n        Time: " +
                                      _vm._s(
                                        _vm
                                          .$moment(
                                            moduleSessionItem.moduleSession[
                                              "sessionTimeRaw"
                                            ],
                                            [
                                              "X",
                                              "DD/MM/YYYY HH:mm",
                                              "DD-MM-YYYY HH:mm",
                                              _vm.$moment.ISO_8601
                                            ]
                                          )
                                          .format("DD-MM-YYYY HH:mm")
                                      ) +
                                      " |\n        Room: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession.roomId
                                      ) +
                                      " |\n        Seat-Left: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession
                                          .seatTotal -
                                          moduleSessionItem.moduleSession
                                            .seatTaken
                                      ) +
                                      "|\n        Language: " +
                                      _vm._s(
                                        moduleSessionItem.moduleSession.language
                                      ) +
                                      " |\n        Pending:" +
                                      _vm._s(
                                        _vm.$store.state.pendingAction
                                          .userCollection[
                                          moduleSessionItem.moduleSession.id
                                        ].length
                                      ) +
                                      "\n      "
                                  )
                                ]
                              )
                      ],
                      1
                    ),
                    _c(
                      "b-collapse",
                      {
                        attrs: {
                          id: "moduleSessionTab[" + index_ms + "]",
                          accordion: "my-accordion",
                          role: "tabpanel"
                        }
                      },
                      [
                        _c(
                          "b-card-body",
                          [
                            _c("b-table", {
                              attrs: {
                                fields: _vm.moduleSessionFields,
                                items: [moduleSessionItem.moduleSession],
                                bordered: "",
                                striped: "",
                                hover: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "pendingApprovalList",
                                  fn: function(row) {
                                    return [
                                      _vm.$store.state.pendingAction
                                        .userCollection[
                                        moduleSessionItem.moduleSession.id
                                      ].length > 0
                                        ? _c(
                                            "section",
                                            [
                                              _c("b-table", {
                                                attrs: {
                                                  fields: _vm.tableFields,
                                                  items:
                                                    _vm.$store.state
                                                      .pendingAction
                                                      .userCollection[
                                                      moduleSessionItem
                                                        .moduleSession.id
                                                    ]
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "viewInfo",
                                                    fn: function(row) {
                                                      return [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-info"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.viewApplicantFiles(
                                                                  row.item,
                                                                  row.index,
                                                                  $event.target
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Files\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-secondary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.viewApplicantWorkingProfile(
                                                                  row.item,
                                                                  row.index,
                                                                  $event.target
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Profile\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.viewApplicantBookedModules(
                                                                  row.item,
                                                                  row.index,
                                                                  $event.target
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Modules\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "actions",
                                                    fn: function(row) {
                                                      return [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-success"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.approveUser(
                                                                  row.item,
                                                                  moduleSessionItem.moduleSession,
                                                                  row.index,
                                                                  $event.target
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Approve\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " |\n                    "
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant: "danger"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                _vm.onRejectUser(
                                                                  row.item,
                                                                  moduleSessionItem.moduleSession,
                                                                  row.index,
                                                                  $event.target
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Reject\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "section",
                                            [
                                              _c(
                                                "b-card",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: {
                                                    "bg-variant": "warning",
                                                    "text-variant": "dark"
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      " No Applicant Pending Approve"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "viewApplicantFilesModal",
                  title: _vm.viewFilesModal.title,
                  "ok-only": ""
                },
                on: {
                  hide: function($event) {
                    _vm.resetModal($event.target)
                  }
                }
              },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  _vm._l(_vm.viewFilesModal.content, function(item, index) {
                    return _c("p", [
                      _vm._v("\n          " + _vm._s(index) + ":\n          "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "/userMsManager/download/" +
                              _vm.viewFilesModal.obj.nricFin +
                              "/" +
                              item,
                            download: item
                          }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(item) + "\n          "
                          )
                        ]
                      )
                    ])
                  })
                )
              ],
              1
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "viewApplicantWorkingProfileModal",
                  title: _vm.viewWorkingProfileModal.title,
                  "ok-only": ""
                },
                on: {
                  hide: function($event) {
                    _vm.resetModal($event.target)
                  }
                }
              },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  _vm._l(
                    _vm.viewWorkingProfileModal.obj.workingProfile,
                    function(item, index) {
                      return _c("p", [
                        !!item
                          ? _c("span", [
                              _vm._v(_vm._s(index) + ": " + _vm._s(item))
                            ])
                          : _vm._e()
                      ])
                    }
                  )
                )
              ],
              1
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "viewApplicantBookedModulesModal",
                  title: _vm.viewBookedModuleModal.title,
                  size: "lg",
                  "ok-only": ""
                },
                on: {
                  hide: function($event) {
                    _vm.resetModal($event.target)
                  }
                }
              },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  _vm._l(_vm.viewBookedModuleModal.content, function(item) {
                    return _c("p", [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.moduleSession.moduleName) +
                          ":\n          " +
                          _vm._s(
                            _vm
                              .$moment(item.moduleSession.sessionTime, "X")
                              .format("DD-MM-YYYY HH:mm")
                          ) +
                          "(Room" +
                          _vm._s(item.roomId) +
                          ") |\n          "
                      ),
                      item.msStatusCode !== 202
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("statusFilter")(item.msStatusCode))
                            )
                          ])
                        : _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(_vm._f("statusFilter")(item.msStatusCode))
                            )
                          ])
                    ])
                  })
                )
              ],
              1
            ),
            _c(
              "b-modal",
              {
                ref: "rejModal" + _vm.remarkModal.rejectUserInfo.nricFin,
                attrs: {
                  id: "addRejectionRemarks",
                  "hide-footer": "",
                  title: _vm.remarkModal.title
                }
              },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c("b-form-textarea", {
                      attrs: {
                        placeholder: "Rejection Remarks",
                        rows: 3,
                        "max-rows": 6
                      },
                      model: {
                        value: _vm.rejRemarks,
                        callback: function($$v) {
                          _vm.rejRemarks = $$v
                        },
                        expression: "rejRemarks"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "b-btn",
                  {
                    staticClass: "mt-3",
                    attrs: { size: "lg", variant: "outline-danger", block: "" },
                    on: {
                      click: function($event) {
                        _vm.resetRemarkModal($event.target)
                      }
                    }
                  },
                  [_vm._v("Reject Booking")]
                )
              ],
              1
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58d4366d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d4366d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/pendingAction/PendingCollection.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-58d4366d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/pendingAction/PendingCollection.vue
// module chunks = 1 4